import type React from 'react';
import { useParams } from 'react-router';
import { News as SharedNews } from '../../shared/news/News';

export const News: React.FC = () => {
  const params = useParams<{ id: string }>();
  if (!params.id) {
    return null;
  }
  return <SharedNews labId={params.id} />;
};
